import colors from '../../../assets/styles/colors';

export const descriptionConfirmation = (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <p style={{color: colors.textPrimary}}>Los siguientes documentos fueron requeridos para avanzar.</p>
        <p style={{color: colors.textPrimary}}>En caso que consideres no viable conseguirlos en menos</p>
        <p style={{color: colors.textPrimary}}>de <b>30 días</b> por favor desiste esta solicitud.</p>
        <br/>
        <ol style={{textAlign: 'left'}}>
            <li>Penúltima declaración de renta</li>
            <li>Última declaración de renta</li>
            <li>Certificado de ingresos y retenciones</li>
            <li>Formato de conocimiento cliente PEP</li>
        </ol>
    </div>
)

export const descriptionSuccess = (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <p style={{color: colors.textPrimary}}>A partir de la fecha tendrás <b>30 días</b> para adjuntar los</p>
        <p style={{color: colors.textPrimary}}>documentos, transcurrido este tiempo la solicitud será</p>
        <p style={{color: colors.textPrimary}}>negada. Recuerda que puede haber cambio de condiciones y</p>
        <p style={{color: colors.textPrimary}}>/ o actualización de las consultas durante este tiempo.</p>
        <br/>
        <ol style={{textAlign: 'left'}}>
            <li>Penúltima declaración de renta</li>
            <li>Última declaración de renta</li>
            <li>Certificado de ingresos y retenciones</li>
            <li>Formato de conocimiento cliente PEP</li>
        </ol>
    </div>
)